import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, Stack, Typography } from "@mui/material";
const PassButtonContent = (param)=>{
    let { rightContent , passContent , isSelected  } = param;
    if (!passContent) {
        return /*#__PURE__*/ _jsx(Box, {
            sx: {
                minHeight: 50
            }
        });
    }
    const titleColor = passContent.isDisabled ? "text.disabled" : isSelected ? "primary.main" : "inherit";
    return /*#__PURE__*/ _jsxs(Stack, {
        sx: {
            flexDirection: "row",
            gap: 1.5,
            width: "100%",
            alignItems: "center",
            minHeight: 50
        },
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        sx: {
                            mb: 0.25,
                            textAlign: "left",
                            color: titleColor,
                            wordBreak: "keep-all",
                            whiteSpace: "normal",
                            overflowWrap: "break-word"
                        },
                        children: passContent.title
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        sx: {
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 0.75
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: passContent.isDisabled ? "body2" : "subtitle2",
                                color: passContent.isDisabled ? "text.disabled" : "blue.400",
                                children: passContent.detailText
                            }),
                            typeof passContent.remainDay === "number" && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Divider, {
                                        orientation: "vertical",
                                        flexItem: true,
                                        sx: {
                                            my: 0.5,
                                            color: "grey.100"
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body2",
                                        color: passContent.isDisabled ? "text.disabled" : "grey.500",
                                        children: "".concat(passContent.remainDay, "일 남음")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            rightContent
        ]
    });
};
export default PassButtonContent;
